import store from "@/store";

export const converterEmbalagemItens = (itens, campos = []) => {
  return itens.map(item => converterEmbalagemItem(item, campos));
};

export const converterEmbalagemItem = (item, campos = []) => {
  const item_convertido = {...item};

  campos.forEach(campo => {
    item_convertido[campo] = converterEmbalagemValor(item, item_convertido[campo]);
  });

  return item_convertido;
};

export const converterEmbalagemValor = ({tipo_fator_conversao, multiplo_compra}, valor) => {
  const embalagem = store.getters["EmbalagemTelaDeCompras/getEmbalagemMaster"];

  if (tipo_fator_conversao === 'M') {
    return embalagem ? valor * Number(multiplo_compra) : valor / Number(multiplo_compra);
  }

  return embalagem ? valor / Number(multiplo_compra) : valor * Number(multiplo_compra);
};

export const converterEmbalagemValorDinheiro = ({tipo_fator_conversao, multiplo_compra}, valor) => {
  const embalagem = store.getters["EmbalagemTelaDeCompras/getEmbalagemMaster"];

  if (tipo_fator_conversao === 'M') {
    return embalagem ? valor / Number(multiplo_compra) : valor * Number(multiplo_compra);
  }

  return embalagem ? valor * Number(multiplo_compra) : valor / Number(multiplo_compra);
};
